(function ($) {
    'use strict';

    var i18n = (ThemeJS.Variables.CartModal && ThemeJS.Variables.CartModal.i18n) || {};

    function getModal() {
        return document.getElementById('flutterbee-add-to-cart-modal');
    }

    function getForm() {
        var modalEl = getModal();
        return modalEl ? $(modalEl).find('[data-flutterbee-cart-form]') : $();
    }

    function getSelectedVariationIdFromPage() {
        var $variationInput = $('form.variations_form input[name="variation_id"]');
        if (!$variationInput.length) {
            return 0;
        }

        return parseInt($variationInput.val(), 10) || 0;
    }

    function resetVariationSelect() {
        var $form = getForm();
        var $wrap = $form.find('[data-flutterbee-cart-variation-wrap]');
        var $select = $form.find('[data-flutterbee-cart-variation-select]');
        var $price = $form.find('[data-flutterbee-cart-variation-price]');

        $wrap.prop('hidden', true);
        $select.prop('disabled', false).empty().append(
            $('<option>', {
                value: '',
                text: i18n.select_isbn || 'Select an ISBN',
            })
        );
        $price.empty().prop('hidden', true);
        setNotice($form, '');
        $form.data('variations', {});
    }

    function setSubmitLoading($button, isLoading, label) {
        var $submitLabel = $button.find('.my-lists-submit-label');
        var $spinner = $button.find('.my-lists-submit-spinner');

        if (isLoading) {
            $button.prop('disabled', true);
            $button.data('original-label', $submitLabel.text());
            $submitLabel.text(label);
            $spinner.prop('hidden', false);
            return;
        }

        $button.prop('disabled', false);
        if ($button.data('original-label')) {
            $submitLabel.text($button.data('original-label'));
        }
        $spinner.prop('hidden', true);
    }

    function setNotice($form, message) {
        var $notice = $form.find('[data-flutterbee-cart-notice]');

        $notice.find('[data-flutterbee-cart-notice-text]').text(message || '');
        $notice.prop('hidden', !message);
    }

    function clearFeedback($form) {
        $form.find('[data-flutterbee-cart-feedback]').empty().prop('hidden', true).removeClass('is-error');
        $form.find('[data-flutterbee-cart-view-cart]').prop('hidden', true);
    }

    function showFeedback($form, message, isError) {
        $form.find('[data-flutterbee-cart-feedback]')
            .text(message)
            .prop('hidden', false)
            .toggleClass('is-error', !!isError);
    }

    function applyCartFragments(fragments, cartHash, $button) {
        if (fragments) {
            $.each(fragments, function (key, value) {
                $(key).replaceWith(value);
            });
        }

        $(document.body).trigger('added_to_cart', [fragments, cartHash, $button]);
    }

    function loadVariations(productId) {
        var $form = getForm();
        var $wrap = $form.find('[data-flutterbee-cart-variation-wrap]');
        var $select = $form.find('[data-flutterbee-cart-variation-select]');
        var deferred = $.Deferred();

        resetVariationSelect();

        ThemeJS.Functions.send_ajax_request({
            data: {
                action: 'flutterbee_cart_get_variations',
                product_id: productId,
            },
            success: function (data) {
                var variations = data.variations || [];
                var requiresVariation = !!data.requires_variation;
                var variationsById = {};

                setNotice($form, data.notice);
                $form.data('requires-variation', requiresVariation).attr('data-requires-variation', requiresVariation ? '1' : '0');

                if (!requiresVariation || !variations.length) {
                    deferred.resolve();
                    return;
                }

                $wrap.prop('hidden', false);

                variations.forEach(function (variation) {
                    variationsById[String(variation.id)] = variation;
                    $select.append(
                        $('<option>', {
                            value: String(variation.id),
                            text: variation.label || variation.isbn || variation.id,
                        })
                    );
                });
                $form.data('variations', variationsById);

                var selectedVariationId = getSelectedVariationIdFromPage();
                if (selectedVariationId && $select.find('option[value="' + selectedVariationId + '"]').length) {
                    $select.val(String(selectedVariationId));
                } else if (variations.length === 1) {
                    $select.val(String(variations[0].id));
                }
                updateVariationPrice($form);

                deferred.resolve();
            },
            error: function () {
                deferred.reject();
            },
        });

        return deferred.promise();
    }

    function updateVariationPrice($form) {
        var variationId = String($form.find('[data-flutterbee-cart-variation-select]').val() || '');
        var variations = $form.data('variations') || {};
        var variation = variations[variationId] || {};
        var priceHtml = variation.price_html || '';
        var $price = $form.find('[data-flutterbee-cart-variation-price]');

        $price.html(priceHtml).prop('hidden', !priceHtml);
    }

    function openCartModal(productId, $trigger) {
        var modalEl = getModal();
        if (!modalEl || typeof bootstrap === 'undefined') {
            return;
        }

        if (modalEl.parentElement !== document.body) {
            document.body.appendChild(modalEl);
        }

        var $form = getForm();
        var $submit = $form.find('[data-flutterbee-cart-submit]');

        $form.data('product-id', productId).attr('data-product-id', productId);
        $form.data('trigger', $trigger);
        $form.data('requires-variation', false).attr('data-requires-variation', '0');
        clearFeedback($form);
        resetVariationSelect();

        bootstrap.Modal.getOrCreateInstance(modalEl).show();

        setSubmitLoading($submit, true, i18n.loading_variations || 'Loading formats...');
        loadVariations(productId)
            .fail(function () {
                showFeedback($form, i18n.error || 'Unable to add product to cart.', true);
            })
            .always(function () {
                setSubmitLoading($submit, false);
            });
    }

    $(function () {
        var modalEl = getModal();
        if (modalEl && modalEl.parentElement !== document.body) {
            document.body.appendChild(modalEl);
        }
    });

    $(document).on('click', '[data-flutterbee-open-cart-modal]', function (event) {
        event.preventDefault();

        var $trigger = $(this);
        var productId = $trigger.data('product-id') || 0;
        openCartModal(productId, $trigger);
    });

    $(document).on('hidden.bs.modal', '#flutterbee-add-to-cart-modal', function () {
        var $form = $(this).find('[data-flutterbee-cart-form]');

        $form[0].reset();
        clearFeedback($form);
        resetVariationSelect();
        setSubmitLoading($form.find('[data-flutterbee-cart-submit]'), false);
    });

    $(document).on('change', '[data-flutterbee-cart-variation-select]', function () {
        updateVariationPrice($(this).closest('[data-flutterbee-cart-form]'));
    });

    $(document).on('submit', '[data-flutterbee-cart-form]', function (event) {
        event.preventDefault();

        var $form = $(this);
        var $button = $form.find('[data-flutterbee-cart-submit]');
        var productId = $form.data('product-id');
        var requiresVariation = String($form.data('requires-variation')) === '1' || String($form.attr('data-requires-variation')) === '1';
        var variationId = $form.find('[data-flutterbee-cart-variation-select]').val() || '';

        clearFeedback($form);

        if (!productId) {
            showFeedback($form, i18n.choose_product || 'Choose a product first.', true);
            return;
        }

        if (requiresVariation && !variationId) {
            showFeedback($form, i18n.select_isbn || 'Select an ISBN.', true);
            return;
        }

        setSubmitLoading($button, true, i18n.adding || 'Adding...');

        ThemeJS.Functions.send_ajax_request({
            data: {
                action: 'flutterbee_modal_add_to_cart',
                product_id: productId,
                variation_id: variationId,
                quantity: 1,
            },
            success: function (data) {
                var $trigger = $form.data('trigger') || $button;
                var modalEl = getModal();

                applyCartFragments(data.fragments, data.cart_hash, $trigger);
                setSubmitLoading($button, false);

                if (modalEl && typeof bootstrap !== 'undefined') {
                    bootstrap.Modal.getOrCreateInstance(modalEl).hide();
                }
            },
            error: function (data) {
                showFeedback($form, data.message || i18n.error || 'Unable to add product to cart.', true);
                setSubmitLoading($button, false);
            },
        });
    });
})(jQuery);
